import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import SharedPlaylistMenu from './SharedPlaylistMenu';
// import SuggestedPlaylistMenu from './SuggestedPlaylistMenu';

function ConnectedListPlaylists({ store }) {
  const sessionPlaylist = (store && store.playlists) ? store.playlists.find( x => x.is_shared) : null;
  // const requestPlaylist = (store && store.playlists) ? store.playlists.find( x => x.is_suggested) : null;
  return (
    <div className={`flexColumn`}>
      { sessionPlaylist && <SharedPlaylistMenu playlist={sessionPlaylist} track_count={sessionPlaylist.tracks.length} /> }
      { /* requestPlaylist && <SuggestedPlaylistMenu playlist={requestPlaylist} track_count={requestPlaylist.tracks.length} /> */ }
    </div>
  )
}

ConnectedListPlaylists.propTypes = {
  store: PropTypes.object
}

const ListPlaylists = connect(
  state => ({
    store: state.storePlaylists
  })
)(ConnectedListPlaylists);

export default ListPlaylists;
